import { Fragment } from 'react';

import { Flex } from 'components/flex';
import { formatPrice } from 'utils/helpers';
import { SemiBold } from 'components/event-modal/styles';

import * as Styles from './styles';
import { SummaryPricesCardProps } from './types';

export const SummaryPricesCard = ({
  items,
  className,
}: SummaryPricesCardProps) => (
  <Styles.Card className={className}>
    {items.map(({ label, price, withSeparate }) => (
      <Fragment key={label}>
        {withSeparate && <Styles.Divider />}
        <Flex justifyContent="space-between">
          <SemiBold>{label}</SemiBold>
          <SemiBold>{formatPrice(price)}</SemiBold>
        </Flex>
      </Fragment>
    ))}
  </Styles.Card>
);
